
















import { Component, Vue, Emit } from 'vue-property-decorator';
import Icon from '../../generic/Icon.vue';
import { ImplementedSourcesGateways } from '../../../helpers/ImplementedSourcesGateways';

@Component({
  components: {
    Icon,
  },
})
export default class GatewaysList extends Vue {
  gateways = ImplementedSourcesGateways;

  @Emit('set-source')
  setSource(source: string) {
    return source;
  }
}
